import {useRecoilState} from 'recoil'
import React from 'react'
import {createVehicleFormState, userProfileFormState} from "../atoms";
import {InputBase} from "../../common";

type Props = {
    type: string
    name: string
    placeholder: string
    disabled?: boolean
    value?: string
}

const Input: React.FC<Props> = ({type, name, placeholder, disabled = false, value}: Props) => {
    const [state, setState] = useRecoilState(userProfileFormState)


    return (
        <InputBase
            className={'base_input'}
            disabled={disabled}
            type={type}
            name={name}
            value={value}
            placeholder={placeholder}
            state={state}
            setState={setState}
        />
    )
}

export default Input
